/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%}.show-loop-link[_ngcontent-%COMP%]{color:#337ab7;cursor:pointer}"];
export { styles as styles };
